export const initialstate = {
	projectId: '',
	groupId: '',
	groupName: '',
	views: [],
	users: [],
	domains: [],
	isBuiltin: false,
	type: 'accessGroup',
	isDuplicate: false
};
